var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.props.tooltip),expression:"props.tooltip"}],class:[
    ((_vm.props.icon) + " tw-text-" + (_vm.props.color) + " tw-text-" + (_vm.props.size)),
    _vm.data.staticClass,
    _vm.data.class ]})}
var staticRenderFns = []

export { render, staticRenderFns }